import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAYvqTMSWVqFdW3vA95oASaRUwWMiy4Ngs",
  authDomain: "cryptophase-19312.firebaseapp.com",
  projectId: "cryptophase-19312",
  storageBucket: "cryptophase-19312.firebasestorage.app",
  messagingSenderId: "1082371863468",
  appId: "1:1082371863468:web:e369541f5834c858f34009"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
